module.exports = __webpack_public_path__ + "media/packs/images/complete-shipment-9d55ccd5b47fdbdc9f61ff10a2af2505.svg";